import { useNavigate, useLocation } from 'react-router-dom';

/**
 * 쿼리스트링을 추가, 업데이트, 또는 삭제하는 함수
 * --
 * @param {string} key - 쿼리스트링의 키
 * @param {string} value - 쿼리스트링의 값 (값이 없으면 삭제)
 */
const useUpdateQuery = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const updateQuery = (key, value, params) => {
    const searchParams = params ? params : new URLSearchParams(location.search);

    if (value) {
      searchParams.set(key, value);
    } else {
      searchParams.delete(key);
    }

    navigate(`${location.pathname}?${searchParams.toString()}`, {
      replace: true,
    });
  };

  return updateQuery;
};

export default useUpdateQuery;
